const CANONICAL_CONDITION_MAP = {
  new: 'New',
  used: 'Used',
  'open box': 'Open Box',
  'open-box': 'Open Box',
  openbox: 'Open Box',
  'like-new': 'Open Box',
  good: 'Used',
  fair: 'Used',
};

const LEGACY_LISTING_TYPE_CONDITION_MAP = {
  new: 'New',
  'sell-used-products': 'Used',
  refurbished: 'Open Box',
  closeout: 'Used',
};

const normalizeConditionValue = value =>
  typeof value === 'string' ? value.trim().toLowerCase() : '';

export const resolveListingCondition = publicData => {
  const normalizedCondition = normalizeConditionValue(publicData?.condition);
  if (normalizedCondition && CANONICAL_CONDITION_MAP[normalizedCondition]) {
    return CANONICAL_CONDITION_MAP[normalizedCondition];
  }

  const normalizedItemCondition = normalizeConditionValue(publicData?.itemCondition);
  if (normalizedItemCondition && CANONICAL_CONDITION_MAP[normalizedItemCondition]) {
    return CANONICAL_CONDITION_MAP[normalizedItemCondition];
  }

  const normalizedListingType = normalizeConditionValue(publicData?.listingType);
  if (
    normalizedListingType &&
    LEGACY_LISTING_TYPE_CONDITION_MAP[normalizedListingType]
  ) {
    return LEGACY_LISTING_TYPE_CONDITION_MAP[normalizedListingType];
  }

  return null;
};

export const listingMatchesCondition = (publicData, selectedConditions = []) => {
  if (!Array.isArray(selectedConditions) || selectedConditions.length === 0) {
    return true;
  }

  const normalizedSelected = selectedConditions
    .map(normalizeConditionValue)
    .map(value => {
      if (CANONICAL_CONDITION_MAP[value]) {
        return CANONICAL_CONDITION_MAP[value];
      }
      if (LEGACY_LISTING_TYPE_CONDITION_MAP[value]) {
        return LEGACY_LISTING_TYPE_CONDITION_MAP[value];
      }
      return null;
    })
    .filter(Boolean);

  if (!normalizedSelected.length) {
    return true;
  }

  const resolvedCondition = resolveListingCondition(publicData);
  return resolvedCondition ? normalizedSelected.includes(resolvedCondition) : false;
};
